import React from 'react';
import logo from './logo.svg';
import './App.css';
import './styles/styles.scss';
//import './styles/bootstrap.min.css';

//export default class App extends React.Component {

    // render () {

    // return (
const App = () => (

    <div className="imglbl">
        This is app.js
        <a href="/page1">Page1</a>


  
      </div>
);

export default App;
//     );
//   }
// }
